<div class="balance-sheet-row" *ngIf="amount !== null">
  <div class="balance-sheet-row-content">
    <span class="ds-ui-2 ds-color-core-neutral-7">{{title | translate}}</span>
    <div>
      <span class="ds-ui-2 ds-color-core-neutral-10">{{amount.toFixed(0) | thousand:currency}}</span>
      <ion-icon name="info2" (click)="clickInfo()"></ion-icon>
    </div>
  </div>
  <div *ngIf="showInfo">
    <span class="ds-ui-3 ds-color-core-neutral-7">{{info | translate}}</span>
  </div>
</div>
